import { BaseList, ChangeControlStatus } from "@design-controls/types";
import { QTagProps } from "@qualio/ui-components";
import i18n from "../i18n/config";

const getMapItemStatus = (): Record<BaseList["itemStatus"], string> => ({
  NEW: i18n.t("statuses.element.new"),
  CHANGED: i18n.t("statuses.element.changed"),
  DELETED: i18n.t("statuses.element.deleted"),
});

const getMapChangeControlStatus = (): Record<
  BaseList["changeControlStatus"],
  string
> => ({
  [ChangeControlStatus.enum.IN_PROGRESS]: i18n.t("statuses.element.inReview"),
  [ChangeControlStatus.enum.APPROVED]: i18n.t("statuses.element.approved"),
  [ChangeControlStatus.enum.NOT_APPROVED]: i18n.t("statuses.element.declined"),
});

export const elementStatus = (
  item: Pick<BaseList, "changeControlStatus" | "itemStatus">,
): string => {
  return item.changeControlStatus === "unstaged" ||
    item.itemStatus === "DELETED"
    ? getMapItemStatus()[item.itemStatus]
    : getMapChangeControlStatus()[item.changeControlStatus];
};

export const ElementStatusTag: Record<string, QTagProps["variantColor"]> = {
  New: "gray",
  Changed: "orange",
  Deleted: "red",
  "In review": "blue",
  Approved: "green",
  Declined: "red",
};
